import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import "./Show.vue?vue&type=style&index=0&id=498bf1e0&scoped=true&lang=css"
script.__scopeId = "data-v-498bf1e0"

export default script